export interface ICalendarType {
    name: string;
    description: string;
    colorId: string;
}

export class CalendarType implements ICalendarType {
    constructor(
        public name: string,
        public description: string,
        public colorId: string
    ) {}
    
}
  